import { environment } from "../../../environments/environment";
import {DocumentoAllegato} from "../../common/models/documento-allegato";

declare var getDominio: any;
declare var getTokenURL: any;
declare var getLoginURL: any;
declare var getDominioReport: any;
declare var getDominioNL: any;
declare var getDominioFlux: any;

export class ServicePathsSettings {
  public static readonly mockAuth: boolean = true;
  public static readonly isLocal: boolean = false;
  public static readonly insLabel: string = "ins";
  public static readonly VIEW_LABEL: string = "view";
  public static readonly useCachedEntity: boolean = false;
  public static readonly DOMINIO: string = environment.url + "services"; // 'http://192.168.12.242:8080/services';
  public static readonly DEFAULT_DIMENSION_RESEARCH_ADEMPIMENTI: number = 20;
  // public static readonly DOMINIO: string = getDominio(); // andrea
  public static readonly DOMINIO_CALENDAR: string =
    "webcal://" + window.location.hostname; // collaudo_eustema_poste 'webcal://192.168.12.242:8080/proxy'
  public static readonly DOMINIO_REPORT: string =
    environment.urlReport + "report"; // 'http://192.168.12.240:8080/report';
  public static readonly DOMINIO_NL: string = environment.url + "services"; // 'http://192.168.12.242:8080/services';
  public static readonly DOMINIO_FLUX: string =
    environment.urlFlux + "services"; // 'http://192.168.12.222:8080/services';
  public static readonly LOGIN_PATH: string =
    environment.url + "services/login"; // 'http://192.168.12.222:8080/services';
  public static readonly LOGOUT_PATH: string =
    environment.url + "services/logout"; // 'http://192.168.12.222:8080/services';
  public static readonly TOKEN_ANTICSRF_PATH: string =
    environment.url + "services"; // 'http://192.168.12.242:8080/services';
  //public static readonly DOMINIO_API_GATEWAY: string = 'http://192.168.12.245:9001';   //URL servizio api gateway TEST
  public static readonly DOMINIO_API_GATEWAY: string =
    environment.urlGateway + "api-gateway"; //URL servizio api gateway NEW TELEFORUM e altri

  public static readonly GET_TOKEN_PATH: string = "/csrftoken";

  public static readonly RS_PATH: string = "/rs";
  public static readonly DESCRITTORI_PATH: string = "/rs/des";
  public static readonly HELPERS_PATH: string = "/rs/hlp";
  public static readonly OPERATIONS_PATH: string = "/rs/ops";
  public static readonly TAB_PATH: string = "/rs/tab";
  public static readonly ANG_PATH: string = "/rs/ang";
  public static readonly SEARCH_PATH: string = "/rs/src";
  public static readonly GESTIONE_PRATICHE_PATH: string = "/gp";
  public static readonly URL_FASCICOLO: string = "/fasc";
  public static readonly URL_PRATICA: string = "/prat";
  public static readonly GESTIONE_PERMESSI_PATH: string = "";

  //URLS PDA CONFIG
  public static readonly URL_PDA_CONFIGURATION = ServicePathsSettings.DOMINIO + ServicePathsSettings.RS_PATH + '/processotelematico/configurations';

  //URLS PDA TPL
  public static readonly URL_PDA_REGISTERS = ServicePathsSettings.DOMINIO + ServicePathsSettings.HELPERS_PATH + ServicePathsSettings.GESTIONE_PRATICHE_PATH + "/registricancelleriatelematica";

  //URLS PDA SECTION
  public static readonly URL_PDA_FASCICOLOPCT = ServicePathsSettings.DOMINIO + ServicePathsSettings.RS_PATH + '/processotelematico/fascicoloPct'
  public static readonly URL_PDA_AUTH = ServicePathsSettings.DOMINIO + ServicePathsSettings.RS_PATH + '/processotelematico/auth'
  public static readonly URL_PDA_CANCELLERIA = ServicePathsSettings.DOMINIO + ServicePathsSettings.RS_PATH + '/processotelematico/cancelleria';
  public static readonly URL_PDA_PAGAMENTI = ServicePathsSettings.DOMINIO + ServicePathsSettings.RS_PATH + '/processotelematico/pagamenti';
  public static readonly URL_GET_SECTIONS = (id : string ,section: string) => {
    return `${ServicePathsSettings.URL_PDA_FASCICOLOPCT}/${id}/${section}`
  }
  public static readonly URL_PDA_DELEGATIONS = ServicePathsSettings.URL_PDA_FASCICOLOPCT + "/deleghe";
  public static readonly URL_GET_CONSULTATION = ServicePathsSettings.URL_PDA_CANCELLERIA + '/dossiers';
  public static readonly URL_PDA_ANON_SEARCH_BY_ROLE = ServicePathsSettings.URL_PDA_CANCELLERIA + '/anonima/ruolo';
  public static readonly URL_PDA_ANON_SEARCH_BY_ROLE_CASS = ServicePathsSettings.URL_PDA_CANCELLERIA + '/anonima/ruolo/cass';
  public static readonly URL_PDA_ANON_SEARCH_BY_DATE = ServicePathsSettings.URL_PDA_CANCELLERIA + '/anonima/data';
  public static readonly URL_UPDATE_FASCICOLOPCT = ServicePathsSettings.URL_PDA_FASCICOLOPCT + "/{idFascicoloPct}";
  public static readonly URL_IMPORT_DATI_GENERALI_PCT = ServicePathsSettings.URL_PDA_FASCICOLOPCT + "/datiGenerali/import";
  public static readonly URL_IMPORT_SCADENZE_PCT = ServicePathsSettings.URL_PDA_FASCICOLOPCT + "/{idFascicoloPct}/adempimenti/import";
  public static readonly URL_IMPORT_DOCUMENTI_PCT = ServicePathsSettings.URL_PDA_FASCICOLOPCT + "/{idFascicoloPct}/documenti/{idAttoPct}/import";
  public static readonly URL_IMPORT_PARTI_PCT = ServicePathsSettings.URL_PDA_FASCICOLOPCT + "/{idFascicoloPct}/parti/import";
  public static readonly URL_CONSULTAZIONE_MASSIVA = ServicePathsSettings.URL_PDA_FASCICOLOPCT + "/consultazionemassiva/{user}";

  //URL PDA PAGAMENTI
  public static URL_PDA_GENERA_AVVISO = ServicePathsSettings.URL_PDA_PAGAMENTI + '/avvisi/genera';
  public static URL_PDA_LISTA_PAGAMENTI = ServicePathsSettings.URL_PDA_PAGAMENTI;
  public static URL_PDA_DOWNLOAD_AVVISO = ServicePathsSettings.URL_PDA_PAGAMENTI + '/avvisi/download';
  public static URL_PDA_DOWNLOAD_RICEVUTA = ServicePathsSettings.URL_PDA_PAGAMENTI + '/ricevute/download';

  public static readonly URL_CREATE_FASCICOLO_PCT = (idFascicolo: string, registro: string) => {
    return `${ServicePathsSettings.URL_PDA_FASCICOLOPCT}/${idFascicolo}/registro/${registro}`;
  };
  public static readonly URL_CREATE_FASCICOLO_PCT_WITHOUT_REGISTRO = (idFascicolo: string) => {
    return `${ServicePathsSettings.URL_PDA_FASCICOLOPCT}/${idFascicolo}`;
  };
  public static readonly URL_DOWNLOAD_DOCUMENTO_PDA = ServicePathsSettings.URL_PDA_FASCICOLOPCT + "/documenti/download";
  public static readonly URL_PREVIEW_DOCUMENTO_PDA = ServicePathsSettings.URL_PDA_FASCICOLOPCT + "/documenti/preview";
  // URLS LEM
  public static readonly URL_LEM = ServicePathsSettings.DOMINIO_API_GATEWAY + "/plugin-legalentitymanagement/"
  public static readonly URL_SCOPES = '/scopes'
  public static readonly URL_TYPES = '/types'
  public static readonly URL_BULK = '/bulk'
  public static readonly URL_PERSON = ServicePathsSettings.URL_LEM + 'persons'
  public static readonly URL_COMPANIES = ServicePathsSettings.URL_LEM + 'companies'
  public static readonly URL_COMPANIES_BODIES = '/bodies'
  public static readonly URL_COMPANIES_DEPARTMENTS = '/departments'
  public static readonly URL_COMPANIES_STATUSES = '/statuses'
  public static readonly URL_MEMBERS = '/members'
  public static readonly URL_ROLE = '/roles'
  public static readonly URL_ALL_MEMBERS_ASSOCIATED = '/all/members/associated'

  // URLS METADATA
  public static readonly URL_METADATA = ServicePathsSettings.DOMINIO + ServicePathsSettings.OPERATIONS_PATH + ServicePathsSettings.GESTIONE_PRATICHE_PATH + '/metadata';
  public static readonly URL_METADATA_TYPES = '/types';
  public static readonly URL_METADATA_PRACTICE_TYPE= '/practiceType';
  public static readonly URL_METADATA_DOSSIER_TYPE = '/dossierType';
  public static readonly URL_METADATA_GET_BY_IDENTIFIER = '/identifier';
  public static readonly URL_METADATA_DISABLE = '/disable';
  public static readonly URL_METADATA_ENABLE = '/enable';
  public static readonly URL_METADATA_ACTIVE = '/active';

  //URLS DATA EXPORT
  public static readonly URL_DATAEXPORT = ServicePathsSettings.DOMINIO + ServicePathsSettings.OPERATIONS_PATH + ServicePathsSettings.GESTIONE_PRATICHE_PATH + '/export';
  public static readonly URL_DATAEXPORT_CREATE = '/create';
  public static readonly URL_DATAEXPORT_ELABORATION = '/elaboration';
  public static readonly URL_DATAEXPORT_DOWNLOAD = '/download';
  public static readonly URL_DATAEXPORT_DELETE = '/delete';


  public static readonly GESTIONE_PRATICHE_BASE_PATH: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH;


  // nome back end pratiche
  public static readonly NOME_BE_PRATICA_LAVORO = "lavoro";
  public static readonly NOME_BE_PRATICA_CIVILE = "civile";
  public static readonly NOME_BE_PRATICA_PENALE = "penale";
  public static readonly NOME_BE_PRATICA_AMMINISTRATIVA = "amministrativa";
  public static readonly NOME_BE_PRATICA_AUTORITA_INDIPENDENTE =
    "autoritaindipendenteregolatoria";
  public static readonly NOME_BE_PRATICA_PARERISTICA = "pareristica";
  public static readonly NOME_BE_PRATICA_TRIBUTARIO = "tributario";

  public static readonly URL_DESCRITTORE_LAVORO: string =
    ServicePathsSettings.DESCRITTORI_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/" +
    ServicePathsSettings.NOME_BE_PRATICA_LAVORO;
  public static readonly URL_DESCRITTORE_CIVILE: string =
    ServicePathsSettings.DESCRITTORI_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/" +
    ServicePathsSettings.NOME_BE_PRATICA_CIVILE;
  public static readonly URL_DESCRITTORE_TRIBUTARIO: string =
    ServicePathsSettings.DESCRITTORI_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/" +
    ServicePathsSettings.NOME_BE_PRATICA_TRIBUTARIO;
  public static readonly URL_DESCRITTORE_PENALE: string =
    ServicePathsSettings.DESCRITTORI_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/" +
    ServicePathsSettings.NOME_BE_PRATICA_PENALE;
  public static readonly URL_DESCRITTORE_AMMINISTRATIVA: string =
    ServicePathsSettings.DESCRITTORI_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/" +
    ServicePathsSettings.NOME_BE_PRATICA_AMMINISTRATIVA;
  public static readonly URL_DESCRITTORE_PARERISTICA: string =
    ServicePathsSettings.DESCRITTORI_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/" +
    ServicePathsSettings.NOME_BE_PRATICA_PARERISTICA;
  public static readonly URL_DESCRITTORE_AUTORITA_INDIPENDENTE: string =
    ServicePathsSettings.DESCRITTORI_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/" +
    ServicePathsSettings.NOME_BE_PRATICA_AUTORITA_INDIPENDENTE;
  public static readonly URL_DESCRITTORE_EMPTY: string =
    ServicePathsSettings.DESCRITTORI_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/verticale-empty";
  public static readonly URL_GET_DESCRITTORI: string =
    ServicePathsSettings.DESCRITTORI_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH;
  // GET
  public static readonly URL_GET_PRATICHE_CORRELATE: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/pratichecorrelate/{idPratica}";
  public static readonly URL_GET_PRATICHE_PRECEDENTI: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/praticheprecedenti/{idPratica}";
  public static readonly URL_GET_SCHEDA_ANALITICA_PRATICA: string =
    "/{idPratica}/scheda/analitica";
  public static readonly URL_GET_SCHEDA_SINTETICA_PRATICA: string =
    "/{idPratica}/scheda/sintetica";
  public static readonly URL_GET_SCHEDA_ANALITICA_FASCICOLO: string =
    "/{idPratica}/scheda/analitica/{idFascicolo}";
  public static readonly URL_GET_SCHEDA_SINTETICA_FASCICOLO: string =
    "/{idPratica}/scheda/sintetica/{idFascicolo}";
  public static readonly URL_GET_NOTIFICHE_ATTIVITA: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/notifiche";
  public static readonly URL_GET_NOTIFICHE_PAGINATE: string =
    ServicePathsSettings.OPERATIONS_PATH + ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/notifiche";
  public static readonly URL_GET_PACCHETTI_PAGINATI: string =
    ServicePathsSettings.OPERATIONS_PATH + ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/tab/richieste-conservazione";
  public static readonly URL_SEGNALA_NOTIFICA_COME_LETTA: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/notificaletta/{idNotifica}";
  public static readonly URL_ELIMINA_NOTIFICA: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/notifica/{idNotifica}";
  // GET TIPOLOGICHE
  // path relativo gli helpers
  public static readonly URL_PATH_HELPERS: string =
    ServicePathsSettings.HELPERS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH;
  //
  // path relativo alla gestione delle tipologiche
  public static readonly URL_PATH_TIPOLOGICHE_CONFIGURATION: string =
    "/rs/tpl/gp";
  public static readonly URL_PATH_ANAGRAFICHE_CONFIGURATION: string =
    "/rs/ang/gp";
  public static readonly URL_PATH_TABELLE_CONFIGURATION: string = "/rs/tab/gp";

  // GESTIONE TIPOLOGICHE
  public static readonly URL_PATH_TIPOLOGICA_BY_ID: string =
    ServicePathsSettings.URL_PATH_TIPOLOGICHE_CONFIGURATION +
    "/{tipologicaTag}/{id}";
  public static readonly URL_PATH_TIPOLOGICA_BY_LABEL: string =
    ServicePathsSettings.URL_PATH_TIPOLOGICHE_CONFIGURATION +
    "/{tipologicaTag}/label/{label}";
  public static readonly URL_PATH_HELPERS_LIST: string =
    ServicePathsSettings.URL_PATH_TIPOLOGICHE_CONFIGURATION +
    "/{tipologicaTag}";
  public static readonly URL_PATH_HELPERS_LIST_ATTIVE: string =
    ServicePathsSettings.URL_PATH_TIPOLOGICHE_CONFIGURATION +
    "/{tipologicaTag}/attive";
  public static readonly URL_PATH_TIPOLOGICA_ADD: string =
    ServicePathsSettings.URL_PATH_TIPOLOGICHE_CONFIGURATION +
    "/{tipologicaTag}";
  public static readonly URL_PATH_TIPOLOGICA_UPDATE: string =
    ServicePathsSettings.URL_PATH_TIPOLOGICHE_CONFIGURATION +
    "/{tipologicaTag}";
  public static readonly URL_PATH_TIPOLOGICA_RESTORE: string =
    ServicePathsSettings.URL_PATH_TIPOLOGICHE_CONFIGURATION +
    "/restore/{tipologicaTag}/{id}";
  public static readonly URL_PATH_TIPOLOGICA_REMOVE: string =
    ServicePathsSettings.URL_PATH_TIPOLOGICHE_CONFIGURATION +
    "/{tipologicaTag}/{id}";
  public static readonly URL_UPDATE_TIPO_DETTAGLIO_ESITO: string =
    ServicePathsSettings.URL_PATH_TIPOLOGICHE_CONFIGURATION +
    "/tipodettagliotipiesito";
  // GESTIONE ANAGRAFICHE
  public static readonly URL_PATH_ANAGRAFICA_BY_ID: string =
    ServicePathsSettings.URL_PATH_ANAGRAFICHE_CONFIGURATION +
    "/{anagraficaTag}/{id}";
  public static readonly URL_PATH_ANAGRAFICA_ADD: string =
    ServicePathsSettings.URL_PATH_ANAGRAFICHE_CONFIGURATION +
    "/{anagraficaTag}";
  public static readonly URL_PATH_ANAGRAFICA_UPDATE: string =
    ServicePathsSettings.URL_PATH_ANAGRAFICHE_CONFIGURATION +
    "/{anagraficaTag}";
  public static readonly URL_PATH_ANAGRAFICA_REMOVE: string =
    ServicePathsSettings.URL_PATH_ANAGRAFICHE_CONFIGURATION +
    "/{anagraficaTag}/{id}";
  public static readonly URL_PATH_ANAGRAFICHE_LIST: string =
    ServicePathsSettings.URL_PATH_ANAGRAFICHE_CONFIGURATION +
    "/{anagraficaTag}";
  public static readonly URL_PATH_ANAGRAFICHE_LIST_ATTIVE: string =
    ServicePathsSettings.URL_PATH_ANAGRAFICHE_CONFIGURATION +
    "/{anagraficaTag}/attive";
  public static readonly URL_PATH_ANAGRAFICA_RESTORE: string =
    ServicePathsSettings.URL_PATH_ANAGRAFICHE_CONFIGURATION +
    "/restore/{anagraficaTag}/{id}";

  // GESTIONE TABELLE
  public static readonly URL_PATH_TABELLA_BY_ID: string =
    ServicePathsSettings.URL_PATH_TABELLE_CONFIGURATION + "/{tabellaTag}/{id}";
  public static readonly URL_PATH_TABELLA_BY_LABEL: string =
    ServicePathsSettings.URL_PATH_TABELLE_CONFIGURATION +
    "/{tabellaTag}/label/{label}";
  public static readonly URL_PATH_TABELLA_HELPERS_LIST: string =
    ServicePathsSettings.URL_PATH_TABELLE_CONFIGURATION + "/{tabellaTag}";
  public static readonly URL_PATH_TABELLA_HELPERS_LIST_ATTIVE: string =
    ServicePathsSettings.URL_PATH_TABELLE_CONFIGURATION +
    "/{tabellaTag}/attive";
  public static readonly URL_PATH_TABELLA_ADD: string =
    ServicePathsSettings.URL_PATH_TABELLE_CONFIGURATION + "/{tabellaTag}";
  public static readonly URL_PATH_TABELLA_UPDATE: string =
    ServicePathsSettings.URL_PATH_TABELLE_CONFIGURATION + "/{tabellaTag}";
  public static readonly URL_PATH_TABELLA_RESTORE: string =
    ServicePathsSettings.URL_PATH_TABELLE_CONFIGURATION +
    "/restore/{tabellaTag}/{id}";
  public static readonly URL_PATH_TABELLA_REMOVE: string =
    ServicePathsSettings.URL_PATH_TABELLE_CONFIGURATION + "/{tabellaTag}/{id}";

  public static readonly URL_MATERIA_PRATICA: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/materie";
  // public static readonly URL_GET_OGGETTI_ALL: string = ServicePathsSettings.URL_PATH_HELPERS + '/oggetti';
  // public static readonly URL_GET_ARGOMENTI_ALL: string = ServicePathsSettings.URL_PATH_HELPERS + '/argomenti';
  public static readonly URL_OGGETTI_PRATICA: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/materia/{idMateria}/oggetti";
  public static readonly URL_MATERIA_OGGETTI: string =
    ServicePathsSettings.URL_PATH_TIPOLOGICHE_CONFIGURATION + "/materiaoggetto";
  public static readonly URL_MATERIA_OGGETTI_BY_ID: string =
    ServicePathsSettings.URL_PATH_TIPOLOGICHE_CONFIGURATION +
    "/materia/{idMateria}";
  public static readonly URL_MATERIA_OGGETTO_ARGOMENTI: string =
    ServicePathsSettings.URL_PATH_TIPOLOGICHE_CONFIGURATION +
    "/materiaoggettoargomento";
  public static readonly URL_MATERIA_OGGETTO_ARGOMENTI_PRODOTTO: string =
    ServicePathsSettings.URL_PATH_TIPOLOGICHE_CONFIGURATION +
    "/materiaoggettoargomentoprodotto";
  public static readonly URL_MATERIA_OGGETTO_ARGOMENTI_PRODOTTO_EVENTI: string =
    ServicePathsSettings.URL_PATH_TIPOLOGICHE_CONFIGURATION +
    "/materiaoggettoargomentoprodottoevento";
  public static readonly URL_MATERIA_OGGETTO_ARGOMENTI_BY_ID: string =
    ServicePathsSettings.URL_PATH_TIPOLOGICHE_CONFIGURATION +
    "/materiaoggetto/{idMateriaOggetto}";
  public static readonly URL_MATERIE_ATTIVE: string =
    ServicePathsSettings.URL_PATH_TIPOLOGICHE_CONFIGURATION + "/materia/attive";
  public static readonly URL_TIPOLOGICHE_MATERIE: string =
    ServicePathsSettings.URL_PATH_TIPOLOGICHE_CONFIGURATION + "/materia";
  public static readonly URL_OGGETTI_ATTIVI: string =
    ServicePathsSettings.URL_PATH_TIPOLOGICHE_CONFIGURATION + "/oggetto/attive";
  public static readonly URL_ARGOMENTI_ATTIVI: string =
    ServicePathsSettings.URL_PATH_TIPOLOGICHE_CONFIGURATION +
    "/argomento/attive";
  public static readonly URL_PRODOTTI_EVENTI_ATTIVI: string =
    ServicePathsSettings.URL_PATH_TIPOLOGICHE_CONFIGURATION +
    "/prodottieventiattivi";
  public static readonly URL_CORRELAZIONE_MATERIA_OGGETTI: string =
    ServicePathsSettings.URL_PATH_TIPOLOGICHE_CONFIGURATION + "/materiaOggetti";
  public static readonly URL_ARGOMENTI_PRATICA: string =
    ServicePathsSettings.URL_PATH_HELPERS +
    "/materia/{idMateria}/oggetto/{idOggetto}/argomenti";
  public static readonly URL_PRODOTTI_PRATICA: string =
    ServicePathsSettings.URL_PATH_HELPERS +
    "/materia/{idMateria}/oggetto/{idOggetto}/argomento/{idArgomento}/prodotti";
  public static readonly URL_EVENTI_PRATICA: string =
    ServicePathsSettings.URL_PATH_HELPERS +
    "/materia/{idMateria}/oggetto/{idOggetto}/argomento/{idArgomento}/prodotto/{idProdotto}/eventi";
  public static readonly URL_GET_APPARTENENZA: string =
    ServicePathsSettings.URL_PATH_HELPERS +
    "/materia/{idMateria}/oggetto/{idOggetto}/argomento/{idArgomento}";
  public static readonly URL_TIPI_PETITUM: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/tipipetitum";
  public static readonly URL_GRADI_RISCHIO_PRATICA: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/gradirischio";
  public static readonly URL_GRADI_PRATICA: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/gradi";
  public static readonly URL_AUTORITA_GIUDIZIARIE_PRATICA: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/autoritagiudiziarie";

  public static readonly URL_ASSOCIATIVA_AUTORITA_SEDE: string =
    ServicePathsSettings.ANG_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/autoritagiudiziariasedeautorita";
  public static readonly URL_FILTER_ASSOCIATIVE_AUTORITA_SEDE: string =
    ServicePathsSettings.ANG_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/filter/autoritagiudiziariasedeautorita";
  public static readonly URL_SOGGETTI_PRATICA: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/soggetti";
  public static readonly URL_SOGGETTI_BY_ID_PRATICA: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/soggetti/materia/{idPratica}";
  public static readonly URL_TIPI_LIQUIDATO: string =
    ServicePathsSettings.URL_PATH_TIPOLOGICHE_CONFIGURATION + "/tipoliquidato";
  public static readonly URL_ARCHIVIA_PRATICA: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/{tipoPratica}/prat/archivia";
  public static readonly URL_ADEMPIMENTI_CALENDARIO: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/adempimenticalendario";
  public static readonly URL_TIPI_REATO: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/tipireato";
  public static readonly URL_TIPI_REVOCAZIONE: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/tipirevocazione";
  public static readonly URL_TIPI_INDAGINE_PRELIMINARE: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/tipiindaginepreliminare";
  public static readonly URL_SEDE_TERRITORIALE: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/sediterritoriali";
  public static readonly URL_CITTA_BY_AUTORITA_PRATICA: string =
    ServicePathsSettings.URL_PATH_HELPERS +
    "/autoritagiudiziaria/{idAutoritaGiudiziaria}/cittaperautorita";
  public static readonly URL_CATEGORIE_LEGALE_INCARICATO_PRATICA: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/categorielegaleincaricato";
  public static readonly URL_CONTROPARTI_BY_SOCIETA: string =
    ServicePathsSettings.URL_SOGGETTI_PRATICA + "/{idSocieta}/controparti";
  public static readonly URL_TIPI_PROVENIENZA_PRATICA: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/tipiprovenienze";
  public static readonly URL_CLASSIFICAZIONE_BY_ID_FASCICOLO: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/pratica/{idPratica}";
  public static readonly URL_TIPI_ESITI_PRATICA: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/tipiesito";
  public static readonly URL_TIPI_ATTO_PRATICA: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/tipiatto";
  public static readonly URL_PROVINCE_PRATICA: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/province";
  public static readonly URL_CITTA_PRATICA: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/provincia/{idProvincia}/citta";
  public static readonly URL_TIPI_SOCIETA_PRATICA: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/tipisocieta";
  public static readonly URL_TIPI_PERSONA_PRATICA: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/tipipersona";
  public static readonly URL_ESITI_BY_SOCIETA_PRATICA: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/esitipersocieta";
  public static readonly URL_TIPI_SCADENZA_PRATICA: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/tipiscadenza";
  public static readonly URL_MOTIVI_SCADENZA_PRATICA: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/motiviscadenza";
  public static readonly URL_MOTIVI_RINVIO_SCADENZA_PRATICA: string =
    "/rs/hlp/gp/motivirinvioscadenza";
  public static readonly URL_MOTIVI_EVADI_SCADENZA_PRATICA: string =
    "/rs/hlp/gp/motivievasioneadempimenti";
  public static readonly URL_TIPI_MOTIVAZIONE: string =
    "/rs/hlp/gp/tipomotivazione";
  public static readonly URL_TIPOLOGIA_GENERICO_GIUDIZIALE: string =
    "/rs/hlp/gp/tipologiagenericogiudiziale";
  public static readonly URL_TIPOLOGIA_GENERICO_CONSULENZA: string =
    "/rs/hlp/gp/tipologiagenericoconsulenza";
  public static readonly URL_PRIORITA_SCDENZA_PRATICA: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/prioritascadenza";
  public static readonly URL_ASSEGNATARI_ADEMPIMENTI: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/assegnatari/{idFascicolo}";
  public static readonly URL_UTENTI_NOTIFICA: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/utenti/{idFascicolo}";
  public static readonly URL_AMBITO_COMPETENZA_PRATICA: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/ambiticompetenza";
  public static readonly URL_TIPI_NATURA_PRATICA: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/tipinatura";
  public static readonly URL_TIPI_AUTORITA_INDIPENDENTE: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/autoritaindipendenti";
  public static readonly URL_TIPI_ARBITRATO_PRATICA: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/tipiarbitrato";
  public static readonly URL_TIPI_NEGOZIAZIONE: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/tipinegoziazione";
  public static readonly URL_CATEGORIE_ALTRA_PARTE: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/categoriealtraparte";
  public static readonly URL_CATEGORIE_CONTROPARTE: string =
    "/categoriecontroparte";
  public static readonly URL_TIPI_DOCUMENTI_DOCUMENTAZIONE_ALLEGATA: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/tipidocumento";
  public static readonly URL_TIPI_PRATICA_GRUPPO_OPERATIVO: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/tipipratica/gruppioperativi/utente";
  public static readonly URL_TIPI_VISIBILITA_DOCUMENTO: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/tipivisibilitadocumento";
  public static readonly URL_TIPI_PRATICA: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/tipipratica";
  public static readonly URL_TIPI_RISERVATEZZA: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/tipovisibilita";
  public static readonly URL_VISIBILITY: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/visibility";
  public static readonly URL_DOCUMENTAZIONE_ALLEGATA: string =
  ServicePathsSettings.OPERATIONS_PATH +
  ServicePathsSettings.GESTIONE_PRATICHE_PATH +
  "/documentazioneallegata/";
  public static readonly URL_TIPI_PRATICA_API_GATEWAY: string =
    "/configuration/rs/tipipratica";
  public static readonly URL_IVA: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/iva";
  public static readonly URL_CPA: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/cpa";
  public static readonly URL_CODICE_FASCICOLO: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/codicefascicolo";
  public static readonly URL_FASI_FASCICOLO: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/fasifascicolo";
  public static readonly URL_TIPI_FASE: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/tipifase";
  public static readonly URL_MOTIVI_PAGAMENTO: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/motivipagamento";
  public static readonly URL_TIPI_SOMMA_LIQUIDATA: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/tipisommaliquidata";
  public static readonly URL_TIPI_SOMMA_DA_CORRISPONDERE: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/tipisomma";
  public static readonly URL_TIPI_PAGAMENTO: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/tipipagamento";
  public static readonly URL_MODALITA_PAGAMENTO: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/modalitapagamento";
  public static readonly URL_MODALITA_EROGAZIONE: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/modalitaerogazione";
  public static readonly URL_TIPI_DETTAGLIO_ESITO: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/tipidettaglio";
  public static readonly URL_COMPETENZE_PARCELLA: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/competenzeparcella";
  public static readonly URL_COMPETENZE_PARCELLA_PRATICA_FASCICOLO: string =
    ServicePathsSettings.URL_PATH_HELPERS +
    "/competenzeparcella/{idTipoPratica}/{idTipoFascicolo}";
  public static readonly URL_SCAGLIONI_PARCELLA: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/scaglioniparcella";
  public static readonly URL_VALORI_PARCELLA_BY_SCAGLIONE: string =
    ServicePathsSettings.URL_PATH_HELPERS +
    "/valoririferimentoparcella/{idScaglioneParcella}";
  public static readonly URL_TIPI_FASCICOLO: string =
    ServicePathsSettings.URL_PATH_HELPERS +
    "/tipopratica/{idTipoPratica}/tipifascicolo";
  public static readonly URL_ALL_TIPI_FASCICOLO: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/tipifascicolo";
  public static readonly URL_ALL_TIPI_FASCICOLO_API_GATEWAY: string =
    "/configuration/rs/tipifascicolo";
  public static readonly URL_STATI_ENTITA: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/statientita";
  public static readonly URL_STATI_PRATICA: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/statipratica";
  public static readonly URL_GET_LOGGER_USER_DATA: string =
    ServicePathsSettings.OPERATIONS_PATH + "/loggeduser";
  public static readonly URL_PATH_CHANGEPWD: string =
    ServicePathsSettings.OPERATIONS_PATH + "/changeUserPwd";
  public static readonly URL_GET_LOGGER_USER_PROFILE: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/loggeduser/profile";
  public static readonly URL_GET_TIPO_TITOLO_ESECUTIVO: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/tipititoloesecutivo";
  public static readonly URL_GET_DIREZIONI_TERRITORIALI_LAVORO: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/direzioniterritorialilavoro";
  public static readonly URL_GET_SOTTO_TIPO_TITOLO_ESECUTIVO: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/sottotipititoloesecutivo";
  public static readonly URL_GET_SOTTO_TIPO_TITOLO_ESECUTIVO_BY_TIPO_TITOLO: string =
    ServicePathsSettings.URL_PATH_HELPERS +
    "/tipotitoloesecutivo/{idTipoTitolo}/sottotipititoloesecutivo";
  public static readonly URL_GET_TIPI_BENE_MOBILI: string =
    ServicePathsSettings.HELPERS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/tipibenemobile";
  public static readonly URL_GET_TIPI_DIRITTO_REALE: string =
    ServicePathsSettings.HELPERS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/tipidirittireale";
  public static readonly URL_TIPI_LETTERA_DIFFIDA: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/tipiletteradiffida";
  public static readonly URL_MOTIVO_ESITO_SPEDIZIONE: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/motiviesitospedizione";
  public static readonly URL_TIPO_ESITO_SPEDIZIONE: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/tipiesitospedizione";
  public static readonly URL_MODALITA_PARTECIPAZIONI: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/modalitapartecipazioni";
  public static readonly URL_TIPI_RITO_ALTERNATIVO: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/tipiritoalternativo";
  public static readonly URL_MOTIVI_DEFINIZIONE: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/motividefinizione";
  public static readonly URL_TIPI_ESECUZIONE: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/tipiesecuzione";
  public static readonly URL_TIPI_SCHEDA_ESECUZIONE: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/tipischedaesecuzione";
  public static readonly URL_TIPI_RICORSO: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/tipiricorso";
  public static readonly URL_TIPI_OPPOSIZIONE: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/tipiopposizione";
  public static readonly URL_PROFILI: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/tipiprofiloprofessionale";
  public static readonly URL_IMPIANTI: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/impianti";
  public static readonly URL_CONTRATTI: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/tipicontratto";
  public static readonly URL_TIPI_DIPENDENTE: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/tipidipendente";
  public static readonly URL_TIPI__STATI_DIPENDENTE: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/statidipendente";
  public static readonly URL_LAVORATORI: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/tipilavoratore";
  public static readonly URL_SANZIONI: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/tipisanzione";
  public static readonly URL_PROVVEDIMENTI: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/tipiprovvedimento";
  public static readonly URL_SOGGETTO_PRATICA: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/soggetto";
  public static readonly URL_TIPO_CONTRATTO: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/tipocontratto";
  public static readonly URL_COMUNI: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/comuni";
  public static readonly URL_TIPI_GIUDIZI: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/tipigiudizio";
  public static readonly URL_FIGURE_PROFESSIONALI: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/figureprofessionali";
  public static readonly URL_FIGURE_PROFESSIONALI_TPL: string =
    ServicePathsSettings.URL_PATH_TIPOLOGICHE_CONFIGURATION +
    "/figuraprofessionale";

  // TIPOLOGICHE FASCICOLI
  public static readonly URL_TIPO_RISOLUZIONE_PRATICA: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/tipirisoluzione";
  public static readonly URL_ORGANI_ISPETTIVI_PRATICA: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/organiispettivi";
  public static readonly URL_LISTA_FORO: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/fori";

  // URL GRUPPI
  public static readonly URL_GET_GRUPPI_TERRITORIALI: string =
    ServicePathsSettings.OPERATIONS_PATH + "/gruppiterritoriali";
  public static readonly URL_GET_GRUPPI_SPECIALI: string =
    ServicePathsSettings.OPERATIONS_PATH + "/gruppispeciali";
  public static readonly URL_GET_GRUPPI_TERRITORIALI_COMPETENTI: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/gruppicompetenti";
  public static readonly URL_GET_GRUPPI_TERRITORIALI_VISIBILITA_ASSOCIATI: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/gruppivisibilita";
  public static readonly URL_AGGIUNGI_UTENTI_A_GRUPPO_TERRITORIALE: string =
    ServicePathsSettings.OPERATIONS_PATH + "/gruppoterritoriale";
  public static readonly URL_AGGIUNGI_UTENTI_A_GRUPPO_SPECIALE: string =
    ServicePathsSettings.OPERATIONS_PATH + "/gruppospeciale";
  public static readonly URL_AGGIUNGI_UTENTI_A_GRUPPO_OPERATIVO: string =
    ServicePathsSettings.OPERATIONS_PATH + "/gruppovisibilitapratica";
  public static readonly URL_AGGIUNGI_UTENTI_A_GRUPPO_VISIBILITA_CLASSIFICAZIONE: string =
    ServicePathsSettings.OPERATIONS_PATH + "/gruppovisibilitaclassificazione";
  public static readonly URL_AGGIUNGI_UTENTI_A_GRUPPO_PERMESSO: string =
    ServicePathsSettings.OPERATIONS_PATH + "/permesso";
  public static readonly URL_AGGIUNGI_UTENTI_A_GRUPPO_RUOLO: string =
    ServicePathsSettings.OPERATIONS_PATH + "/ruolo";
  public static readonly URL_GET_UTENTI_BY_GRUPPO_VIS_CLASSIFICAZIONE: string =
    ServicePathsSettings.OPERATIONS_PATH +
    "/utentidagruppivisibilitaclassificazione";
  public static readonly URL_GET_UTENTI_BY_GRUPPO_TERRITORIALE: string =
    ServicePathsSettings.OPERATIONS_PATH + "/utentidagruppiterritoriali";
  public static readonly URL_GET_UTENTI_BY_GRUPPO_SPECIALE: string =
    ServicePathsSettings.OPERATIONS_PATH + "/utentidagruppispeciali";
  public static readonly URL_GET_UTENTI_BY_GRUPPO_OPERATIVO: string =
    ServicePathsSettings.OPERATIONS_PATH + "/utentidagruppioperativi";
  public static readonly URL_GET_UTENTI_BY_PERMESSO: string =
    ServicePathsSettings.OPERATIONS_PATH + "/utentidapermessi";
  public static readonly URL_GET_UTENTI_BY_RUOLO: string =
    ServicePathsSettings.OPERATIONS_PATH + "/utentidaruoli";
  public static readonly URL_GET_GRUPPI_FILTER: string =
    ServicePathsSettings.OPERATIONS_PATH + "/gruppi";
  public static readonly URL_GET_ASSEGNATARI: string =
    ServicePathsSettings.OPERATIONS_PATH + "/assegnataridagruppiterritoriali/";
  public static readonly URL_GET_UTENTE_ASSEGNATARIO: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/utenteassegnatario";
  public static readonly URL_GET_UTENTI_ASSEGNATARI: string =
    ServicePathsSettings.OPERATIONS_PATH +
    "/utentiassegnatari";

  public static readonly URL_PRENDI_ATTIVITA_COMPLETARE: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/attivita";
  public static readonly URL_GET_TIPO_CATASTO: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/tipicatasto";
  public static readonly URL_GET_TIPO_DATI_DENUNCIA: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/tipidatidenuncia";
  public static readonly URL_GET_TIPI_PROVA_SCRITTA: string =
    ServicePathsSettings.URL_PATH_HELPERS + "/tipiprovascritta";
  // TEMPLATE UTENTE
  public static readonly URL_GET_TEMPLATE_GRUPPI_OPERATIVI: string =
    ServicePathsSettings.OPERATIONS_PATH + "/gruppioperativi";
  public static readonly URL_GET_TEMPLATE_GRUPPI_ORGANIZZATIVI: string =
    ServicePathsSettings.OPERATIONS_PATH + "/gruppiterritoriali";
  public static readonly URL_GET_TEMPLATE_GRUPPI_VISIBILITA: string =
    ServicePathsSettings.OPERATIONS_PATH + "/gruppivisibilita";
  public static readonly URL_GET_TEMPLATE_RUOLI: string =
    ServicePathsSettings.OPERATIONS_PATH + "/ruoli";
  public static readonly URL_GET_TEMPLATE_PERMESSI: string =
    ServicePathsSettings.OPERATIONS_PATH + "/permessi";

  public static readonly URL_GET_UTENTI: string =
    ServicePathsSettings.OPERATIONS_PATH + "/utente";

  // public static readonly URL_ADD_RINVIO_SCADENZA: string = ServicePathsSettings.OPERATIONS_PATH + ServicePathsSettings.GESTIONE_PRATICHE_PATH + '/fascicolo/{idFascicolo}/scadenza/{idScadenza}/rinvio';
  public static readonly URL_ADD_RINVIO_SCADENZA: string =
    "/sez/scadenze/{idSezione}/scadenza/{idScadenza}/rinvio";
  public static readonly URL_EVADI_SCADENZA: string =
    "/sez/scadenze/{idSezione}/scadenza/{idScadenza}/evasa";

  public static readonly URL_RINVIO_ADEMPIMENTO: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/scadenza/{idScadenza}/rinvio";
  public static readonly URL_EVADI_ADEMPIMENTO: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/scadenza/{idScadenza}/evadi";

  // PUT
  public static readonly URL_UPDATE_UTENTE_ASSEGNATARIO: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/assegnatari";
  public static readonly URL_UPDATE_EVADI_SCADENZA: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/scadenza/{idScadenza}/evasa";
  //public static readonly URL_UPDATE_ESITO_SPEDIZIONE_TO_LETTERA_DIFFIDA: string = ServicePathsSettings.OPERATIONS_PATH + ServicePathsSettings.GESTIONE_PRATICHE_PATH + '/letteradiffida/{idLetteraDiffida}/esitospedizione';
  public static readonly URL_UPDATE_ESITO_SPEDIZIONE_TO_LETTERA_DIFFIDA: string =
    "/sez/letteradiffida/{idSezione}/letteradiffida/{idLetteraDiffida}/esitospedizione";

  // public static readonly URL_ADD_ESITO_SPEDIZIONE_TO_LETTERA_DIFFIDA: string = ServicePathsSettings.OPERATIONS_PATH + ServicePathsSettings.GESTIONE_PRATICHE_PATH + '/letteradiffida/{idLetteraDiffida}/esitospedizione';
  public static readonly URL_ADD_ESITO_SPEDIZIONE_TO_LETTERA_DIFFIDA: string =
    "/sez/letteradiffida/{idSezione}/letteradiffida/{idLetteraDiffida}/esitospedizione";
  //public static readonly URL_DELETE_ESITO_SPEDIZIONE_TO_LETTERA_DIFFIDA: string = ServicePathsSettings.OPERATIONS_PATH + ServicePathsSettings.GESTIONE_PRATICHE_PATH + '/letteradiffida/{idLetteraDiffida}/esitospedizione/{idEsitoSpedizione}';
  public static readonly URL_DELETE_ESITO_SPEDIZIONE_TO_LETTERA_DIFFIDA: string =
    "/sez/letteradiffida/{idSezione}/letteradiffida/{idLetteraDiffida}/esitospedizione/{idEsitoSpedizione}";
  public static readonly UPDATE_PARTE: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/parte";
  public static readonly URL_UPDATE_DETTAGLI_ESITO: string =
    "/sez/esiti/{idEsito}/dettagli";
  public static readonly URL_ADD_MERITO_TO_ESITO: string =
    "/sez/esiti/{idSezione}/esito/{idEsito}/dettaglioesito";
  public static readonly URL_ADD_DETTAGLI_TO_ESITO: string =
    "/sez/esiti/{idEsito}/dettagli";
  public static readonly URL_INSERT_LIQUIDATI_ESITO: string =
    "/{idFascicolo}/sez/economici/{idSezione}/add/liquidati";
  //public static readonly URL_DELETE_MERITO_TO_ESITO: string = ServicePathsSettings.OPERATIONS_PATH + ServicePathsSettings.GESTIONE_PRATICHE_PATH + '/esito/{idEsito}/dettaglioesito/{idDettaglioEsito}';
  public static readonly URL_EDIT_LIQUIDATI_ESITO: string =
    "/{idFascicolo}/sez/economici/{idSezione}/liquidati";
  public static readonly URL_DELETE_MERITO_TO_ESITO: string =
    "/sez/esiti/{idSezione}/esito/{idEsito}/dettaglioesito/{idDettaglioEsito}";
  public static readonly DOWNLOAD_DOCUMENTO: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/download/documento";
  public static readonly DOWNLOAD_DOCUMENTO_BY_REF: string =
    ServicePathsSettings.OPERATIONS_PATH +
    "/download/documento";
  public static readonly DOWNLOAD_ALL_DOCUMENTS: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/download/alldocuments";
  public static readonly DOWNLOAD_CSV: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/download/terminiscadenzario/csv";
  public static readonly URL_GET_DOCUMENTO: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/documento";
  public static readonly DELETE_FILE_TO_DOCUMENTALE: string =
    ServicePathsSettings.OPERATIONS_PATH + "/file";
  public static readonly URL_UPDATE_METADATI_DOCUMENTO: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/documento";
  public static readonly URL_UPDATE_METADATI_DOCUMENTO_NEW_VERSION: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/newdocumentversion";
  public static readonly URL_UPLOAD_DOCUMENTO: string =
    ServicePathsSettings.OPERATIONS_PATH + "/file/upload";
  public static readonly URL_UPLOAD_DOCUMENTO_TEMP: string =
    ServicePathsSettings.OPERATIONS_PATH + "/file/temp"

  public static readonly URL_ELABORATION_TEMP: string = ServicePathsSettings.RS_PATH + `/elaborazione/documenti/allegati`

  public static readonly URL_ELABORATION = (id:string) => {
    return ServicePathsSettings.RS_PATH + `/elaborazione/${id}`
  }

  public static readonly URL_GET_ELABORATION_DOCUMENTS = (id: string) => {
    return `${ServicePathsSettings.RS_PATH}/elaborazione/${id}/documenti`
  }

  public static readonly URL_GET_ELABORATION_TOPICS = (id: string) => {
    return `${ServicePathsSettings.RS_PATH}/elaborazione/${id}/topic`
  }

  public static readonly URL_GET_ELABORATION_SEZIONI = (id: string) => {
    return `${ServicePathsSettings.RS_PATH}/elaborazione/${id}/sezioni`
  }

  public static readonly URL_GET_ELABORATION_ENTITIES = (id: string) => {
    return `${ServicePathsSettings.RS_PATH}/elaborazione/${id}/entita`
  }
  public static readonly URL_GET_ELABORATION_SIMILAR_DOCUMENTS = (id: string) => {
    return `${ServicePathsSettings.RS_PATH}/elaborazione/${id}/documenti/simili`
  }
  public static readonly URL_GET_ELABORATION_CITATIONS = (id: string) => {
    return `${ServicePathsSettings.RS_PATH}/elaborazione/${id}/documenti/citazioni`
  }

  public static readonly URL_GET_ELABORATION_PRATICHE = (id: string) => {
    return `${ServicePathsSettings.RS_PATH}/elaborazione/${id}/pratiche`
  }

  public static readonly URL_GET_ELABORATION_PRATICHE_ANNO_RUOLO = (anno: string,ruolo: string) => {
    return `${ServicePathsSettings.RS_PATH}/elaborazione/pratiche/${anno}/${ruolo}`
  }



  public static readonly URL_ELABORATION_FASCICOLO_TEMP = (id: string) => {
    return `${ServicePathsSettings.RS_PATH}/elaborazione/${id}/fascicolo`
  }

  public static readonly URL_ELABORATION_FASCICOLO_TEMP_PDA = (id: string) => {
    return `${ServicePathsSettings.RS_PATH}/elaborazione/${id}/fascicolo/JUSTICE_PDA`
  }

  public static readonly URL_ASSOCIA_FASCICOLO = (idElaborazione: string, idFascicolo: string) => {
    return `${ServicePathsSettings.RS_PATH}/elaborazione/${idElaborazione}/associa/${idFascicolo}`
  }


  public static readonly URL_FETCH_DOCUMENT_ELABORATIONS: string =
    ServicePathsSettings.RS_PATH + "/elaborazione/filter"
  public static readonly URL_FETCH_STEP_WIZARD_PRTICA: string =
    ServicePathsSettings.RS_PATH + "/elaborazione/step/list"
  public static readonly URL_SEND_DOCUMENT_ELABORATION: string =
    ServicePathsSettings.RS_PATH + "/elaborazione"
  public static readonly URL_GET_ELABORATION_STATUS_LIST: string =
    ServicePathsSettings.RS_PATH +"/elaborazione/stati/list"
  public static readonly URL_UPLOAD_NEW_VERSION_DOCUMENTO: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/newdocumentversion";
  public static readonly URL_UPLOAD_NEW_VERSION_DOCUMENTO_MISSING_FILE: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/newdocumentversionmissingfile";
  public static readonly DOWNLOAD_DOCUMENTO_BY_ID_DOCUMENTALE: string =
    ServicePathsSettings.OPERATIONS_PATH + "/download";
  public static readonly URL_GET_HISTORY_DOCUMENT_VERSION: string =
    ServicePathsSettings.OPERATIONS_PATH + ServicePathsSettings.GESTIONE_PRATICHE_PATH + "/versionhistory";
  public static readonly URL_ADD_DOCUMENTO_TO_CONTROPARTE: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/controparte/{entityId}/documento";
  public static readonly URL_ADD_DOCUMENTO_TO_PATOLOGIA: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/patologia/{entityId}/documento";
  public static readonly URL_ADD_DOCUMENTO_TO_SCHEDA_RECUPERO: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/schedarecupero/{entityId}/documento";
  public static readonly URL_ADD_DOCUMENTO_TO_SCHEDA_ESECUZIONE: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/schedaesecuzione/{entityId}/documento";
  public static readonly URL_REMOVE_DOCUMENTO_FROM_CONTROPARTE: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/controparte/{entityId}/documento/{idDocumento}";
  public static readonly URL_REMOVE_DOCUMENTO_FROM_PATOLOGIA: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/patologia/{entityId}/documento/{idDocumento}";
  public static readonly URL_REMOVE_DOCUMENTO_FROM_SCHEDA_RECUPERO: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/schedarecupero/{entityId}/documento/{idDocumento}";
  public static readonly URL_REMOVE_DOCUMENTO_FROM_SCHEDA_ESECUZIONE: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/schedaesecuzione/{entityId}/documento/{idDocumento}";
  public static readonly URL_ADD_DOCUMENTO_TO_LEGALE_INCARICATO: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/legale/{entityId}/documento";
  public static readonly URL_REMOVE_DOCUMENTO_FROM_LEGALE_INCARICATO: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/legale/{entityId}/documento/{idDocumento}";
  public static readonly URL_ADD_DOCUMENTO_TO_ALTRAPARTE: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/altraParte/{entityId}/documento";
  public static readonly URL_REMOVE_DOCUMENTO_FROM_ALTRAPARTE: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/altraParte/{entityId}/documento/{idDocumento}";
  public static readonly URL_ADD_DOCUMENTO_TO_SCADENZA: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/scadenza/{entityId}/documento";
  public static readonly URL_REMOVE_DOCUMENTO_FROM_SCADENZA: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/scadenza/{entityId}/documento/{idDocumento}";
  public static readonly URL_ADD_DOCUMENTO_TO_ATTO: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/atto/{entityId}/documento";
  public static readonly URL_REMOVE_DOCUMENTO_FROM_ATTO: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/atto/{entityId}/documento/{idDocumento}";
  public static readonly URL_ADD_DOCUMENTO_TO_ESITO: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/esito/{entityId}/documento";
  public static readonly URL_REMOVE_DOCUMENTO_FROM_ESITO: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/esito/{entityId}/documento/{idDocumento}";
  public static readonly URL_ADD_DOCUMENTO_TO_PAGAMENTO: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/pagamento/{entityId}/documento";
  public static readonly URL_REMOVE_DOCUMENTO_FROM_PAGAMENTO: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/pagamento/{entityId}/documento/{idDocumento}";
  public static readonly URL_ADD_DOCUMENTO_TO_INCASSO: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/incasso/{entityId}/documento";
  public static readonly URL_REMOVE_DOCUMENTO_FROM_INCASSO: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/incasso/{entityId}/documento/{idDocumento}";
  public static readonly URL_ADD_DOCUMENTO_TO_PARCELLA: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/parcella/{entityId}/documento";
  public static readonly URL_REMOVE_DOCUMENTO_FROM_PARCELLA: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/parcella/{entityId}/documento/{idDocumento}";
  public static readonly URL_ADD_DOCUMENTO_TO_FATTURA: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/fattura/{entityId}/documento";
  public static readonly URL_REMOVE_DOCUMENTO_FROM_FATTURA: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/fattura/{entityId}/documento/{idDocumento}";
  public static readonly URL_ADD_DOCUMENTO_TO_LETTERA_DIFFIDA: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/letteradiffida/{entityId}/documento";
  public static readonly URL_REMOVE_DOCUMENTO_FROM_LETTERA_DIFFIDA: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/letteradiffida/{entityId}/documento/{idDocumento}";
  public static readonly URL_ADD_DOCUMENTO_TO_BENEIMMOBILE: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/benepignoratoimmobile/{entityId}/documento";
  public static readonly URL_REMOVE_DOCUMENTO_FROM_BENEIMMOBILE: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/benepignoratoimmobile/{entityId}/documento/{idDocumento}";
  public static readonly URL_ADD_DOCUMENTO_TO_BENEMOBILE: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/benepignoratomobile/{entityId}/documento";
  public static readonly URL_REMOVE_DOCUMENTO_FROM_BENEMOBILE: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/benepignoratomobile/{entityId}/documento/{idDocumento}";
  public static readonly URL_ADD_DOCUMENTO_TO_PROVASCRITTA: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/provascritta/{entityId}/documento";
  public static readonly URL_REMOVE_DOCUMENTO_FROM_PROVASCRITTA: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/provascritta/{entityId}/documento/{idDocumento}";
  public static readonly URL_ADD_DOCUMENTO_TO_TITOLO_ESECUTIVO: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/titoloesecutivo/{entityId}/documento";
  public static readonly URL_REMOVE_DOCUMENTO_FROM_TITOLO_ESECUTIVO: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/titoloesecutivo/{entityId}/documento/{idDocumento}";
  public static readonly URL_CORRELA_PRATICHE: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/pratichecorrelate/{idPratica}";
  public static readonly URL_UPDATE_ANAGRAFICA_PARTE: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/parte";
  public static readonly URL_UPDATE_ANAGRAFICA_LEGALE: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/legale";
  public static readonly URL_ESITO_TO_SCADENZA: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/scadenza/{entityId}/dettaglioesitoadempimento";

  // POST
  public static readonly URL_AGGIORNAMENTO_MASSIVO_CLASSIFICAZIONI: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/aggiornaclassificazioni";
  public static readonly URL_CALCOLA_INTERESSI_LEGALI: string =
    ServicePathsSettings.TAB_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/interessilegali/calcolo";
  public static readonly URL_ADD_ANAGRAFICA_PARTE: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/parte";
  public static readonly URL_ADD_ANAGRAFICA_LEGALE: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/legale";
  public static readonly URL_ADD_GRUPPO_VISIBILITA: string =
    ServicePathsSettings.OPERATIONS_PATH + "/gruppovisibilita";
  public static readonly URL_ADD_GRUPPO_TERRITORIALE: string =
    ServicePathsSettings.OPERATIONS_PATH + "/gruppoterritoriale";

  // DELETE
  public static readonly URL_DELETE_PRATICHE_CORRELATE: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/pratichecorrelate/{idPratica}/{idPraticaDaScorrelare}";
  public static readonly URL_DELETE_PRATICA_PRECEDENTE: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/praticheprecedenti/{idPratica}/{idPraticaPrecedente}";

  // RICERCA
  public static readonly URL_SEARCH_PARTI_TUTTE: string =
    ServicePathsSettings.SEARCH_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/parte/all";
  public static readonly URL_SEARCH_PARTE: string =
    ServicePathsSettings.SEARCH_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/parte";
  public static readonly URL_SEARCH_LEGALI_TUTTI: string =
    ServicePathsSettings.SEARCH_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/legale/all";
  public static readonly URL_SEARCH_LEGALE: string =
    ServicePathsSettings.SEARCH_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/legale";
  public static readonly URL_GET_PARTE: string =
    ServicePathsSettings.HELPERS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/parte/{idParte}";
  public static readonly URL_GET_LEGALE: string =
    ServicePathsSettings.HELPERS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/legale/{idLegale}";
  public static readonly URL_SEARCH_ADEMPIMENTI: string =
    ServicePathsSettings.SEARCH_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/adempimenti";
  public static readonly URL_SEARCH_ATTI: string =
    ServicePathsSettings.SEARCH_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/atti";
  // PARCELLA
  public static readonly URL_BUILD_PARCELLA: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/prospettoparcella";

  // ADEMPIMENTI
  public static readonly URL_PROSSIMI_ADEMPIMENTI: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/adempimentiprossimi";
  public static readonly URL_ADEMPIMENTI_INEVASI: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/adempimentiscaduti";
  public static readonly URL_REMOVE_SCADENZA_ADEMPIMENTI: string =
    "/eliminascadenza/{idFascicolo}/{idScadenza}";

  public static readonly URL_DELETE_ESITO_TO_SCADENZA: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
  "/scadenza/{entityId}/dettaglioesitoadempimento/{idDettaglioAdempimento}";


  // COPIA PRATICA
  public static readonly URL_COPIA_PRATICA: string = "/pratica";

  // RIUNISCI GIUDIZI
  public static readonly URL_RIUNISCI_GIUDIZI: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/riunione";
  public static readonly URL_UPDATE_RIUNISCI_GIUDIZI: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/riunione";
  public static readonly URL_REMOVE_RIUNISCI_GIUDIZI: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/riunione/elimina";
  public static readonly URL_GET_FASCICOLI_RIUNIONE: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/riunione/all";
  // SCHEDA ANALITICA
  public static readonly URL_SCHEDA_ANALITICA: string = "schedaanalitica";

  // REPORT
  public static readonly REPORT_PRATICHE_PATH: string = "/rs/pratiche";
  public static readonly REPORT_PRATICHE_SINTESI: string =
    ServicePathsSettings.REPORT_PRATICHE_PATH + "/sintesi";
  public static readonly REPORT_PRATICHE_ANDAMENTO_PRATICHE: string =
    ServicePathsSettings.REPORT_PRATICHE_PATH + "/andamento-pratiche";
  public static readonly REPORT_PRATICHE_ANDAMENTO_PETITUM: string =
    ServicePathsSettings.REPORT_PRATICHE_PATH + "/andamento-petitum";
  public static readonly REPORT_PRATICHE_PENDENTI_XLS: string =
    ServicePathsSettings.REPORT_PRATICHE_PATH + "/pendenti/xls";
  public static readonly REPORT_PRATICHE_ARCHIVIATE_XLS: string =
    ServicePathsSettings.REPORT_PRATICHE_PATH + "/archiviate/xls";
  public static readonly REPORT_PRATICHE_DEFINITE_XLS: string =
    ServicePathsSettings.REPORT_PRATICHE_PATH + "/definite/xls";
  public static readonly REPORT_FASCICOLI_PATH: string = "/rs/fascicoli";
  public static readonly REPORT_FASCICOLI_SINTESI: string =
    ServicePathsSettings.REPORT_FASCICOLI_PATH + "/sintesi";
  public static readonly REPORT_FASCICOLI_IN_LAVORAZIONE_XLS: string =
    ServicePathsSettings.REPORT_FASCICOLI_PATH + "/inlavorazione/xls";
  public static readonly REPORT_FASCICOLI_DEFINITI_XLS: string =
    ServicePathsSettings.REPORT_FASCICOLI_PATH + "/definiti/xls";
  public static readonly REPORT_FASCICOLI_NON_MOVIMENTATI_XLS: string =
    ServicePathsSettings.REPORT_FASCICOLI_PATH + "/nonmovimentati/xls";
  public static readonly REPORT_FASCICOLI_TOTALE_XLS: string =
    ServicePathsSettings.REPORT_FASCICOLI_PATH + "/totale/xls";
  public static readonly REPORT_ESITI_PATH: string = "/rs/esiti";
  public static readonly REPORT_LIQUIDATI_PATH: string = "/rs/liquidati";
  public static readonly REPORT_ESITI_SINTESI: string =
    ServicePathsSettings.REPORT_ESITI_PATH + "/sintesi";
  public static readonly REPORT_LIQUIDATI_SINTESI: string =
    ServicePathsSettings.REPORT_LIQUIDATI_PATH + "/sintesi";
  public static readonly REPORT_ESITI_XLS: string =
    ServicePathsSettings.REPORT_ESITI_PATH + "/xls";
  public static readonly REPORT_LIQUIDATI_XLS: string =
    ServicePathsSettings.REPORT_LIQUIDATI_PATH + "/xls";
  public static readonly REPORT_CLASSIFICAZIONI_PATH: string =
    "/rs/classificazioni";
  public static readonly REPORT_CLASSIFICAZIONI_SINTESI: string =
    ServicePathsSettings.REPORT_CLASSIFICAZIONI_PATH + "/sintesi";
  public static readonly REPORT_CLASSIFICAZIONI_XLS: string =
    ServicePathsSettings.REPORT_CLASSIFICAZIONI_PATH + "/xls";
  public static readonly REPORT_MENSILIZZAZIONI_PATH: string =
    "/rs/estrazionedati/mensilizzazioni";
  public static readonly REPORT_MENSILIZZAZIONI_XLS: string =
    ServicePathsSettings.REPORT_MENSILIZZAZIONI_PATH + "/xls";
  public static readonly REPORT_BILANCIO_PATH: string = "/rs/bilancio";
  public static readonly REPORT_BILANCIO_XLS: string =
    ServicePathsSettings.REPORT_BILANCIO_PATH + "/xls";
  public static readonly REPORT_PAGAMENTI_PATH: string = "/rs/pagamenti";
  public static readonly REPORT_SINTETICO_PAGAMENTI_XLS: string =
    ServicePathsSettings.REPORT_PAGAMENTI_PATH + "/sintetico/xls";
  public static readonly REPORT_ANALITICO_PAGAMENTI_XLS: string =
    ServicePathsSettings.REPORT_PAGAMENTI_PATH + "/analitico/xls";
  public static readonly REPORT_INCASSI_PATH: string = "/rs/incassi";
  public static readonly REPORT_SINTETICO_INCASSI_XLS: string =
    ServicePathsSettings.REPORT_INCASSI_PATH + "/sintetico/xls";
  public static readonly REPORT_ANALITICO_INCASSI_XLS: string =
    ServicePathsSettings.REPORT_INCASSI_PATH + "/analitico/xls";
  public static readonly REPORT_INCARICHI_PATH: string = "/rs/incarichi";
  public static readonly REPORT_INCARICHI_XLS: string =
    ServicePathsSettings.REPORT_INCARICHI_PATH + "/xls";
  public static readonly REPORT_PERFORMANCE_PATH: string = "/rs/performance";
  public static readonly REPORT_PERFORMANCE_XLS: string =
    ServicePathsSettings.REPORT_PERFORMANCE_PATH + "/xls";
  public static readonly REPORT_ACCANTONAMENTI_PATH: string =
    "/rs/accantonamenti";
  public static readonly REPORT_ACCANTONAMENTI_XLS: string =
    ServicePathsSettings.REPORT_ACCANTONAMENTI_PATH + "/xls";
  public static readonly REPORT_ADEMPIMENTI_PATH: string = "/rs/adempimenti";
  public static readonly REPORT_ADEMPIMENTI_XLS: string =
    ServicePathsSettings.REPORT_ADEMPIMENTI_PATH + "/xls";
  public static readonly REPORT_MOD770_PATH: string = "/rs/mod770";
  public static readonly REPORT_VERIFICA_MOD770_XLS: string =
    ServicePathsSettings.REPORT_MOD770_PATH + "/verifica/xls";
  public static readonly REPORT_SIMULA_MOD770_XLS: string =
    ServicePathsSettings.REPORT_MOD770_PATH + "/simula/xls";
  public static readonly REPORT_FLUSSO_MOD770_INVIO: string =
    ServicePathsSettings.REPORT_MOD770_PATH + "/flusso/invio";
  public static readonly REPORT_ESTRAZIONE_DATI_PATH: string =
    "/rs/estrazionedati";
  public static readonly REPORT_ESTRAZIONE_DATI_XLS: string =
    ServicePathsSettings.REPORT_ESTRAZIONE_DATI_PATH + "/xls";
  public static readonly REPORT_ESTRAZIONE_DATI_CONSULENZA_DISCIPLINA_XLS: string =
    ServicePathsSettings.REPORT_ESTRAZIONE_DATI_PATH + "/xls-cd";
  public static readonly REPORT_LISTA_FILE_ARCHIVIO: string =
    "/rs/listafilearchivio";
  public static readonly REPORT_DOWNLOAD_FILE_ARCHIVIO: string =
    "/rs/download/";
  public static readonly REPORT_FATTURE_PATH: string = "/rs/fatture";
  public static readonly REPORT_SINTETICO_FATTURE_XLS: string =
    ServicePathsSettings.REPORT_FATTURE_PATH + "/sintetico/xls";
  public static readonly REPORT_ANALITICO_FATTURE_XLS: string =
    ServicePathsSettings.REPORT_FATTURE_PATH + "/analitico/xls";
  public static readonly REPORT_PARCELLE_PATH: string = "/rs/parcelle";
  public static readonly REPORT_SINTETICO_PARCELLE_XLS: string =
    ServicePathsSettings.REPORT_PARCELLE_PATH + "/sintetico/xls";
  public static readonly REPORT_ANALITICO_PARCELLE_XLS: string =
    ServicePathsSettings.REPORT_PARCELLE_PATH + "/analitico/xls";
  public static readonly PERFORMANCE_PATH: string =
    ServicePathsSettings.REPORT_PERFORMANCE_PATH + "/topten";

  //MIA RICERCA
  public static readonly TEMPLATE_ADD: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/template";
  public static readonly TEMPLATE_ESTRAZIONE_ADD: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/templateestrazione";
  public static readonly IMPOSTA_TEMPLATE_PREDEFINITO: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/template/predefinito/{idTemplate}/{location}";
  public static readonly LIST_TEMPLATES: string =
    ServicePathsSettings.SEARCH_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/templates/all/{location}";
  public static readonly ELIMINA_TEMPLATE: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/template/{idTemplate}";

  //ADEMPIMENTI CALENDARIO outlook
  public static readonly URL_ADEMPIMENTI_CALENDARIO_ICALENDAR: string =
    ServicePathsSettings.URL_ADEMPIMENTI_CALENDARIO +
    "/icalendar";

  //FORMULARIO
  public static readonly URL_FORMULARIO: string = "/formulario/";
  public static readonly URL_SCADENZA: string = "/scadenza/";
  public static readonly URL_SCADENZARIO: string = "/scadenzario/";

  //MENU
  public static readonly PATH_MENU: string = "/menu" + ServicePathsSettings.RS_PATH;
  public static readonly PATH_MENU_FASCICOLO: string = ServicePathsSettings.PATH_MENU + "/menufascicolo";

  public static readonly URL_MENU_FASCICOLO = (idTipoPratica: string, idTipoFascicolo: string) => {
    return ServicePathsSettings.DOMINIO_API_GATEWAY + ServicePathsSettings.PATH_MENU_FASCICOLO + `/${idTipoPratica}/${idTipoFascicolo}`;
  }

  //SCADENZARIO
  public static readonly URL_DELETE_CONFIGURAZIONE_GRADO: string =
    "/rs/scadenzario/delete/configurazione/{idPratica}/{idFascicolo}/{idGrado}";
  public static readonly URL_DELETE_CONFIGURAZIONE: string =
    "/rs/scadenzario/delete/configurazione/{idPratica}/{idFascicolo}";

  //delibera e letera ricorrente
  public static readonly GENERA_DELIBERA: string =
    ServicePathsSettings.OPERATIONS_PATH + "/gp/download/template/delibera/";
  public static readonly GENERA_LETTERA_RICCORRENTE: string =
    ServicePathsSettings.OPERATIONS_PATH +
    "/gp/download/template/letteraRicorrente/";

  //FASCICOLO
  public static readonly URL_DESCRITTORI_FASCICOLO = (tipoPratica: string, idTipoPratica: string, idTipoFascicolo: string) => {
    return ServicePathsSettings.DOMINIO
      + ServicePathsSettings.URL_GET_DESCRITTORI
      + `/${tipoPratica}`
      + ServicePathsSettings.URL_FASCICOLO
      + `/${idTipoPratica}/${idTipoFascicolo}`;
  }


  public static readonly URL_ADD_DOCUMENTO_TO_DATI_PIGNORAMENTO: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/datipignoramento/{entityId}/documento";
  public static readonly URL_REMOVE_DOCUMENTO_FROM_DATI_PIGNORAMENTO: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/datipignoramento/{entityId}/documento/{idDocumento}";

  // CONFIGURATION
  public static readonly CONFIGURATION_PATH: string =
    ServicePathsSettings.RS_PATH +
    "/configurations"

  // PROTOCOL
  public static readonly PROTOCOL_PATH: string =
    ServicePathsSettings.OPERATIONS_PATH +
    ServicePathsSettings.GESTIONE_PRATICHE_PATH +
    "/protocols"
  public static readonly PROTOCOL_ORIGINS_PATH: string =
    ServicePathsSettings.PROTOCOL_PATH +
    "/origins"
  public static readonly PROTOCOL_DOSSIERS_PATH: string =
    ServicePathsSettings.PROTOCOL_PATH +
    "/dossiers"
  public static readonly PROTOCOL_IMPORT_PATH: string =
    ServicePathsSettings.PROTOCOL_PATH +
    "/dossiers/import"
  public static readonly PROTOCOL_PREVIEW_PATH: string =
    ServicePathsSettings.PROTOCOL_PATH +
    "/dossiers/preview"
  public static readonly PROTOCOL_UFFICI_PATH: string =
    ServicePathsSettings.PROTOCOL_PATH +
    "/offices/"
  public static readonly PROTOCOL_DOCUMENT_PATH: string =
    "/documents"
  public static readonly URL_DOSSIER_DOCUMENT =(idDossier:string) => {
    return ServicePathsSettings.PROTOCOL_DOSSIERS_PATH + '/' + idDossier + ServicePathsSettings.PROTOCOL_DOCUMENT_PATH
  }

  // SIGN DOCUMENTS
  public static readonly URL_SIGN = (servicePath: string) => {
    return ServicePathsSettings.DOMINIO + ServicePathsSettings.RS_PATH + '/sign' + servicePath;
  };

  public static readonly URL_SIGN_DOCUMENTS_CONFIGURATIONS =
    ServicePathsSettings.URL_SIGN('/configurations');

  public static readonly URL_SIGN_DOCUMENTS =
    ServicePathsSettings.URL_SIGN('/documents');

  public static readonly URL_SIGN_REMOTE = (servicePath?: string) => {
    return ServicePathsSettings.URL_SIGN('/remote' + (servicePath || ""));
  }

  public static readonly URL_SIGN_REMOTE_START = (format: string, document: DocumentoAllegato) => {
    return ServicePathsSettings.URL_SIGN_REMOTE(`/start-transaction/${format}/${document.refDocumentale}`);
  }

  // SIGN APP
  public static readonly URL_SIGN_APP = (servicePath: string) => {
    return "http://localhost:8443"+servicePath
  }

  public static readonly URL_SIGN_LOCAL: string =
    ServicePathsSettings.URL_SIGN_APP("/sign/documents");

  public static readonly URL_SIGN_LOCAL_HEALTH_CHECK: string =
    ServicePathsSettings.URL_SIGN_APP("/sign/documents/health");

     // MARK DOCUMENTS
  public static readonly URL_MARK:string =  ServicePathsSettings.OPERATIONS_PATH + ServicePathsSettings.GESTIONE_PRATICHE_PATH + "/mark/documento";
}
